import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import ProductLevelSelectionButtonContainer from './ProductLevelSelectionButtonContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const ResponsiveFlex = styled.div.withConfig({
  displayName: "HubProductLevelPicker__ResponsiveFlex",
  componentId: "sc-5td3xi-0"
})(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  [trellisBreakpoint.tabletPortrait]: {
    gap: theme.space[100]
  },
  [trellisBreakpoint.phone]: {
    flexDirection: 'column'
  }
}));
const HubProductLevelPicker = ({
  productLine,
  selectedProductLevel,
  setSelectedProductLevel,
  ariaLabelledById,
  isLoading
}) => {
  return /*#__PURE__*/_jsx(ResponsiveFlex, {
    role: "group",
    "aria-labelledby": ariaLabelledById,
    children: currentOrderedPaidProductLevels.map(productLevel => {
      const isProductLevelSelected = selectedProductLevel === productLevel;
      return /*#__PURE__*/_jsx(ProductLevelSelectionButtonContainer, {
        productLine: productLine,
        productLevel: productLevel,
        selected: isProductLevelSelected,
        disabled: isLoading,
        onClick: () => {
          if (!isProductLevelSelected) {
            setSelectedProductLevel(productLevel);
          } else {
            setSelectedProductLevel(null);
          }
        }
      }, productLevel);
    })
  });
};
export default HubProductLevelPicker;